import { get } from "jquery";
import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";

//const Rellax = require("rellax");
//const rellaxCSS = require("rellax/css/main.css");

export default () => {

    //var rellax = new Rellax('.rellax');

    $('body').off('click',".jsGallery")
    .on("click", ".jsGallery", function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const photoIndex = $(this)
            .parent()
            .parent()
            .data('slick-index');

            initGallery(photoIndex);
    });

    // fix 2 embeds on one field
    if ($('.video-container-embbed iframe').length > 1)
    {
        var iframeArray = new Array();
        $('.video-container-embbed').find('iframe').each(function(){
            //iframeArray.push($(this).get(0));
            iframeArray.push($(this).get(0).outerHTML);
            console.log($(this).get(0).outerHTML);
        });
        console.log(iframeArray);
        var parent = $('.video-container-embbed').parent()
        parent.html("");
        for (var i=0;i<iframeArray.length;i++) {
            parent.append('<div class="video-container-embbed">'+iframeArray[i]+'</div>');
            
        }
    }

    initArchtrendsListener();

    function initGallery(photoIndex) {
        const pswpElement = document.querySelectorAll(".pswp")[0];

        let photos = [...document.querySelectorAll('#gallery .imageGallery img')].map((photo, index) => {
            return {
                src: photo.dataset.original,
                high_src: photo.dataset.max,
                w: window.innerWidth,
                h: window.innerHeight,
                title: photo.dataset.caption,
                index
            };
        });

        if(photos.length == 0) {
            photos = [...document.querySelectorAll('#gallery .imageGallery img')].map((photo,index) => {
                return {
                    src: photo.dataset.original,
                    high_src: photo.dataset.max,
                    w: window.innerWidth,
                    h: window.innerHeight,
                    title: photo.dataset.caption,
                    index
                };
            });
        }
        
        const options = {
            index: photoIndex,
            zoomEl: false,
            shareEl: true,
            tapToToggleControls: false,
            getDoubleTapZoom: function(isMouseClick, item) {
                if(isMouseClick) {
                    gallery.shout("mouseZoom", item);
                    item.resized = true;
                    return 3; //<---- This 3
                } else {
                    return item.initialZoomLevel < 0.7 ? 3 : 1.33; //<---- 3 here
                }
            },
            shareButtons: [
                {id:'download', label:'Download', url:'{{raw_image_url}}', download:true}
            ]
        };
        const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, photos, options);

        gallery.listen("mouseZoom", function(item) {
            if (!item.resized) {
                photos[item.index].src = item.high_src;

                // Update gallery content.
                gallery.invalidateCurrItems();
                gallery.updateSize(true);
            }
        });

        gallery.listen("close", function(e) {
            $("body").removeClass("noScroll");
        })

        gallery.listen('imageLoadComplete', function(index, item) {                 
            $("body").addClass("noScroll");
        });

        gallery.init();
    }

    function initArchtrendsListener( e )  {
        // mostrar modal de vídeo
        $("a.jsArchtrends").on("click", function(e) {
            e.preventDefault();
            var title = $(this).data("title"); //
            var url = $(this).attr("href"); //
            
            
    
            var embed =
            '<iframe width="100%" height="100%" src="'+url+'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
            UtilUi.loadTemplate("assets/modal-archtrends.tpl", function(dataContact, tpl) {
                var html = tpl.fetch({
                    firstLanguage: lang,
                    title: title,
                    urlImageServer: urlImageServer,
                    urlHome: urlhome,
                    embed: embed,
                });
                $("body").append(html);
                $("#modal-archtrends").modal("show");
    
                $("#modal-archtrends").on("hide.bs.modal", function(e) {
                    $(this).remove();
                });
            });
            return false;
        });
    };
    
}